import AddComment from './AddComment.container';

export default AddComment;
